// Individual Image Loaders for Gallery
document.addEventListener('DOMContentLoaded', function () {
  // Get all gallery pictures
  const galleryPictures = document.querySelectorAll('.brn-product__gallery__picture');

  if (galleryPictures.length === 0) {
    return;
  }

  // Process each picture individually
  galleryPictures.forEach((picture) => {
    const img = picture.querySelector('img');
    const loader = picture.querySelector('.loader');

    if (!img || !loader) {
      return;
    }

    function showLoader() {
      loader.classList.remove('loader--hidden');
    }

    function hideLoader() {
      loader.classList.add('loader--hidden');
    }

    // Check if image is already loaded (cached)
    if (img.complete && img.naturalHeight !== 0) {
      hideLoader();
      return;
    }

    // Show loader initially for all images that need to load
    showLoader();

    // Hide loader when image loads or fails
    img.addEventListener('load', () => {
      hideLoader();
    });

    img.addEventListener('error', () => {
      hideLoader();
    });
  });

  // Auto-open sheet functionality (mobile only)
  function initAutoOpenSheet() {
    // Only run on mobile devices
    if (window.innerWidth > 1023) return;

    const galleryContainer = document.querySelector('.brn-product__gallery');
    const sheet = document.querySelector('#product-sheet');

    if (!galleryContainer || !sheet) return;

    let isAtEnd = false;
    let lastScrollTop = 0;

    function checkScrollEnd() {
      const scrollTop = galleryContainer.scrollTop;
      const scrollHeight = galleryContainer.scrollHeight;
      const clientHeight = galleryContainer.clientHeight;

      // Calculate if we're at the bottom (with small threshold)
      const threshold = 50;
      const atBottom = scrollTop + clientHeight >= scrollHeight - threshold;

      if (atBottom && !isAtEnd) {
        isAtEnd = true;
        // Add visual feedback that sheet can be opened
        galleryContainer.style.setProperty('--scroll-end-indicator', '1');
      } else if (!atBottom && isAtEnd) {
        isAtEnd = false;
        galleryContainer.style.removeProperty('--scroll-end-indicator');
      }
    }

    function handleScrollAttempt(e) {
      if (!isAtEnd) return;

      const scrollTop = galleryContainer.scrollTop;
      const scrollHeight = galleryContainer.scrollHeight;
      const clientHeight = galleryContainer.clientHeight;

      // Check if trying to scroll down when already at bottom
      const isScrollingDown = e.deltaY > 0 || (e.touches && e.touches[0] && lastScrollTop > galleryContainer.scrollTop);

      if (isScrollingDown && scrollTop + clientHeight >= scrollHeight - 10) {
        e.preventDefault();

        // Open sheet if it exists and has openSheet function
        if (window.openSheet && typeof window.openSheet === 'function') {
          window.openSheet();
        } else {
          // Fallback: trigger click on sheet header if available
          const sheetHeader = document.querySelector('.brn-product__sheet__header');
          if (sheetHeader) {
            sheetHeader.click();
          }
        }
      }
    }

    // Touch handling for mobile
    let touchStartY = 0;
    let touchEndY = 0;

    function handleTouchStart(e) {
      touchStartY = e.touches[0].clientY;
    }

    function handleTouchMove(e) {
      if (!isAtEnd) return;

      touchEndY = e.touches[0].clientY;
      const scrollTop = galleryContainer.scrollTop;
      const scrollHeight = galleryContainer.scrollHeight;
      const clientHeight = galleryContainer.clientHeight;

      // Check if swiping up (trying to scroll down) at bottom
      const isSwipingUp = touchStartY > touchEndY;
      const atBottom = scrollTop + clientHeight >= scrollHeight - 10;

      if (isSwipingUp && atBottom) {
        e.preventDefault();

        // Open sheet
        if (window.openSheet && typeof window.openSheet === 'function') {
          window.openSheet();
        } else {
          const sheetHeader = document.querySelector('.brn-product__sheet__header');
          if (sheetHeader) {
            sheetHeader.click();
          }
        }
      }
    }

    // Event listeners
    galleryContainer.addEventListener('scroll', () => {
      checkScrollEnd();
      lastScrollTop = galleryContainer.scrollTop;
    });

    // Mouse wheel for desktop testing
    galleryContainer.addEventListener('wheel', handleScrollAttempt, { passive: false });

    // Touch events for mobile
    galleryContainer.addEventListener('touchstart', handleTouchStart, { passive: true });
    galleryContainer.addEventListener('touchmove', handleTouchMove, { passive: false });

    // Initial check
    checkScrollEnd();
  }

  // Initialize auto-open functionality
  initAutoOpenSheet();

  // Re-initialize on window resize (orientation change)
  window.addEventListener('resize', () => {
    setTimeout(initAutoOpenSheet, 100);
  });

  // =====================
  // Zoom Overlay (Desktop & Mobile)
  // =====================
  function initGalleryZoom() {
    const overlay = document.querySelector('[data-zoom-overlay]');
    if (!overlay) return;

    const inner = overlay.querySelector('[data-zoom-inner]');
    const closeBtn = overlay.querySelector('[data-zoom-close]');
    const prevBtn = overlay.querySelector('[data-zoom-prev]');
    const nextBtn = overlay.querySelector('[data-zoom-next]');
    const stage = overlay.querySelector('[data-zoom-stage]');
    const swiperEl = overlay.querySelector('[data-zoom-swiper]');
    const slidesWrapper = overlay.querySelector('[data-zoom-slides]');
    const featuredImage = document.querySelector('.brn-product__featured__image');
    const galleryImages = Array.from(document.querySelectorAll('[data-gallery] .brn-product__gallery__image'));
    const zoomImages = (featuredImage ? [featuredImage] : []).concat(galleryImages);

    let isOpen = false;
    let isMobile = window.innerWidth <= 810;
    let swiperInstance = null;
    let desktopImg = null;
    let maxPanY = 0;

    function lockScroll() {
      document.body.classList.add('is--zoom-open');
    }
    function unlockScroll() {
      document.body.classList.remove('is--zoom-open');
    }

    function showOverlay() {
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      isOpen = true;
      lockScroll();
    }

    function hideOverlay() {
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      isOpen = false;
      unlockScroll();
      // Cleanup desktop image
      if (desktopImg) {
        desktopImg.remove();
        desktopImg = null;
      }
      maxPanY = 0;
      // Cleanup swiper
      if (swiperInstance && typeof swiperInstance.destroy === 'function') {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
      if (slidesWrapper) slidesWrapper.innerHTML = '';
      // Restore ARIA
      stage && stage.setAttribute('aria-hidden', 'true');
      swiperEl && swiperEl.setAttribute('aria-hidden', 'true');
    }

    function onEsc(e) {
      if (e.key === 'Escape' && isOpen) {
        hideOverlay();
      }
    }

    let currentDesktopIndex = 0;
    let handleImageClick = null;
    let handleMouseMove = null;
    let handleKeyNav = null;

    function loadDesktopImage(index) {
      if (!stage || index < 0 || index >= zoomImages.length) return;

      currentDesktopIndex = index;
      const targetImg = zoomImages[index];
      const lowSrc = targetImg.currentSrc || targetImg.src;
      const highSrc = targetImg.dataset.zoomSrc;

      // Clean up old image
      if (desktopImg) {
        desktopImg.remove();
      }

      desktopImg = new Image();
      desktopImg.className = 'brn-product__zoom__image';
      desktopImg.src = lowSrc;

      desktopImg.onload = function () {
        const naturalH = desktopImg.naturalHeight;
        const naturalW = desktopImg.naturalWidth;
        const viewportH = window.innerHeight;
        const scaledH = naturalH * (window.innerWidth / naturalW);
        maxPanY = Math.max(0, Math.round(scaledH - viewportH));

        if (highSrc) {
          const hiRes = new Image();
          hiRes.onload = function () {
            desktopImg.src = highSrc;
            const scaledHHi = hiRes.naturalHeight * (window.innerWidth / hiRes.naturalWidth);
            maxPanY = Math.max(0, Math.round(scaledHHi - viewportH));
          };
          hiRes.src = highSrc;
        }
      };

      stage.innerHTML = '';
      stage.appendChild(desktopImg);

      // Re-attach click handler
      if (handleImageClick) {
        desktopImg.addEventListener('click', handleImageClick);
      }
    }

    function navigateToPrev() {
      const prevIndex = (currentDesktopIndex - 1 + zoomImages.length) % zoomImages.length;
      loadDesktopImage(prevIndex);
    }

    function navigateToNext() {
      const nextIndex = (currentDesktopIndex + 1) % zoomImages.length;
      loadDesktopImage(nextIndex);
    }

    function openDesktopZoom(targetImg) {
      if (!stage || !inner) return;

      // Find index of clicked image
      currentDesktopIndex = zoomImages.indexOf(targetImg);
      if (currentDesktopIndex === -1) currentDesktopIndex = 0;

      // Prepare stage
      stage.setAttribute('aria-hidden', 'false');
      swiperEl && swiperEl.setAttribute('aria-hidden', 'true');

      // Show navigation arrows
      if (prevBtn) prevBtn.hidden = false;
      if (nextBtn) nextBtn.hidden = false;

      showOverlay();
      loadDesktopImage(currentDesktopIndex);

      // Don't focus close button to avoid outline

      // Click on image to close zoom (desktop only)
      handleImageClick = function (e) {
        e.stopPropagation();
        hideOverlay();
      };
      stage.addEventListener('click', handleImageClick);

      // Mouse move maps Y to translateY
      handleMouseMove = function (e) {
        if (!desktopImg) return;
        if (maxPanY <= 0) {
          desktopImg.style.transform = 'translate3d(0,0,0)';
          return;
        }
        const ratioY = e.clientY / window.innerHeight;
        const offsetY = Math.round(ratioY * maxPanY);
        desktopImg.style.transform = `translate3d(0, ${-offsetY}px, 0)`;
      };
      inner.addEventListener('mousemove', handleMouseMove);

      // Keyboard navigation
      handleKeyNav = function (e) {
        if (!isOpen) return;
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          navigateToPrev();
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          navigateToNext();
        }
      };
      document.addEventListener('keydown', handleKeyNav);

      // Button navigation
      if (prevBtn) {
        prevBtn.addEventListener('click', navigateToPrev);
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', navigateToNext);
      }

      // Remove event listeners on hide
      const prevHide = hideOverlay;
      hideOverlay = function () {
        inner.removeEventListener('mousemove', handleMouseMove);
        stage && stage.removeEventListener('click', handleImageClick);
        document.removeEventListener('keydown', handleKeyNav);
        if (prevBtn) {
          prevBtn.removeEventListener('click', navigateToPrev);
          prevBtn.hidden = true;
        }
        if (nextBtn) {
          nextBtn.removeEventListener('click', navigateToNext);
          nextBtn.hidden = true;
        }
        handleImageClick = null;
        handleMouseMove = null;
        handleKeyNav = null;
        prevHide();
        hideOverlay = prevHide;
      };
    }

    function buildSlides() {
      if (!slidesWrapper) return;
      slidesWrapper.innerHTML = '';
      zoomImages.forEach((imgEl) => {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        const slideImg = new Image();
        slideImg.className = 'brn-product__zoom__image';
        const lowSrc = imgEl.currentSrc || imgEl.src;
        const highSrc = imgEl.dataset.zoomSrc;
        slideImg.src = lowSrc;
        if (highSrc) {
          const hiRes = new Image();
          hiRes.onload = function () { slideImg.src = highSrc; };
          hiRes.src = highSrc;
        }
        slide.appendChild(slideImg);
        slidesWrapper.appendChild(slide);
      });
    }

    function openMobileZoom(startIndex) {
      if (!swiperEl) return;
      stage && stage.setAttribute('aria-hidden', 'true');
      swiperEl.setAttribute('aria-hidden', 'false');

      buildSlides(startIndex);
      showOverlay();
      closeBtn && closeBtn.focus({ preventScroll: true });

      // Initialize Swiper if available
      if (window.Swiper) {
        swiperInstance = new window.Swiper(swiperEl, {
          loop: true,
          initialSlide: startIndex || 0,
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 300,
        });
      }
    }

    // Close interactions
    closeBtn && closeBtn.addEventListener('click', hideOverlay);
    document.addEventListener('keydown', onEsc);

    // Image interactions
    zoomImages.forEach((imgEl, index) => {
      imgEl.addEventListener('click', function () {
        isMobile = window.innerWidth <= 810;
        if (isMobile) {
          openMobileZoom(index);
        } else {
          openDesktopZoom(imgEl);
        }
      }, { passive: true });
    });

    // Public API (optional)
    window.initGalleryZoom = initGalleryZoom;
  }

  // Initialize zoom
  initGalleryZoom();
});
